import styled from 'styled-components';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  display: block;
  width: 100%;
  min-width: 150px;
  // using this height so user can scroll the table horizontally
  // because this table has infinite scroll
  height: 100%;
  max-height: 87vh;
  overflow-x: auto;
  overflow-y: scroll;
`;

export const ContainerSearch = styled.div`
  display: flex;
  width: 500px;
`;

export const Title = styled(TextLayoutComponent.Title)`
  margin-bottom: 25px;
`;

export const ContainerTop = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
